import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

const CorrectPageContainer: React.FC = () => {
  const isArchivePage = (pathname: string) => {
    switch (pathname) {
      case "/person/":
      case "/team/":
      case "/project/list/":
      case "/event/":
      case "/topics/":
      case "/facility/list/":
        return true;
      default:
        return false;
    }
  };

  // トレイリングスラッシュありのURLを生成します
  // パラメータはページ番号のみ受け付けます
  const genCanonicalURL = (pathname: string, search: string) => {
    let url = window.location.origin;
    const convertedPath = pathname.endsWith("/") ? pathname : pathname + "/";

    url += convertedPath;

    if (search && isArchivePage(convertedPath)) {
      const pg = new URLSearchParams(search).get("pg");

      // pg=1の場合除去します（pgパラメータの有無で評価が分散するのを防ぎます）
      url += pg && pg !== "1" ? `?pg=${pg}` : "";
    }

    return url;
  };

  let canonical = document.querySelector('link[rel="canonical"]');
  const location = useLocation();

  const renderFlgRef = useRef(false);

  useEffect(() => {
    // 最初のレンダリングでcanonicalが存在しない場合は、headタグ内に追加します
    if (canonical === null) {
      const newCanonical = document.createElement("link");
      newCanonical.setAttribute("rel", "canonical");
      newCanonical.setAttribute(
        "href",
        genCanonicalURL(location.pathname, location.search)
      );
      document.head.appendChild(newCanonical);

      canonical = newCanonical;
    }

    // エラーページ用
    return () => {
      if (canonical !== null) {
        canonical.remove();
      }
    };
  }, []);

  // canonicalの書き換え（2回目以降）
  useEffect(() => {
    if (!renderFlgRef.current) {
      renderFlgRef.current = true;
      return;
    }

    if (canonical !== null) {
      canonical.setAttribute(
        "href",
        genCanonicalURL(location.pathname, location.search)
      );
    }
  }, [location]);

  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default CorrectPageContainer;
